import React, { useState, useRef, useEffect } from 'react';
import { useSwiper } from 'swiper/react';
import { Hint } from 'fronton-react';
import { PopperPlacement } from 'fronton-react/utils';

interface HintWrapperProps {
  children: React.ReactNode;
  anchor: React.ReactElement;
  placement?: PopperPlacement;
  dataQa?: string;
  toggleModal?: () => void;
  isMobileView?: boolean;
}

export const HintWrapper: React.FC<HintWrapperProps> = ({
  children,
  anchor,
  placement = 'bottom',
  dataQa = 'banner/hint',
  toggleModal,
  isMobileView,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hintRef = useRef<HTMLDivElement>(null);
  const swiper = useSwiper();

  const toggleHintState = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    if (toggleModal && isMobileView) {
      toggleModal();
    } else {
      setIsOpen(prev => !prev);
    }
  };

  const handleClickOutside = (event: PointerEvent) => {
    if (hintRef.current && !hintRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('pointerdown', handleClickOutside);
    return () => {
      document.removeEventListener('pointerdown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      swiper?.autoplay?.stop();
    } else {
      swiper?.autoplay?.start();
    }
  }, [isOpen, swiper?.autoplay]);

  return (
    <div ref={hintRef} data-qa={dataQa}>
      <Hint
        anchor={React.cloneElement(anchor, { onClick: toggleHintState })}
        placement={placement}
        open={isOpen}>
        <div onPointerDown={e => e.stopPropagation()}>{children}</div>
      </Hint>
    </div>
  );
};
